
import Ruler from "../../../assets/outline/Ruler.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RulerIcon({ className, dataTestid = "RulerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Ruler data-testid={dataTestid} className={classes} {...rest} />
  );
}
